import { createContext, useContext } from "react";

const RecaptchaLoadContext = createContext(() => {});

export const useRecaptchaLoader = () => useContext(RecaptchaLoadContext);

export default RecaptchaLoadContext;
